export const RuotaMark = ({ size = 32, className = "", duration = 18, aqua = "#168A91", gold = "#E2725B", ballR = 6 }) => (
  <svg
    viewBox="0 0 100 100"
    width={size}
    height={size}
    className={className}
    style={{ animation: `ruota-spin ${duration}s linear infinite` }}
    aria-hidden="true"
  >
    <circle
      cx="50"
      cy="50"
      r="42"
      fill="none"
      stroke={aqua}
      strokeWidth="6"
      strokeLinecap="round"
      strokeDasharray="200 64"
    />
    <circle
      cx="50"
      cy="50"
      r="42"
      fill="none"
      stroke={gold}
      strokeWidth="6"
      strokeLinecap="round"
      strokeDasharray="40 224"
      strokeDashoffset="-200"
    />
    <circle cx="90.3" cy="38.2" r={ballR} fill={gold} />
  </svg>
);
